import { PointsLog } from '@/types/pointsLog';

// Gambling and admin soko adjustments move `soko_points`; everything else
// (chat, follows, subs, rewards, promos, admin kick adjustments, orders)
// moves `points`.
export function getPointsLogCurrency(item: Pick<PointsLog, 'event_type'>): 'points' | 'soko_points' {
    return item.event_type?.startsWith('gambling.') || item.event_type?.startsWith('admin.soko')
        ? 'soko_points'
        : 'points';
}
